import { useQuery } from '@apollo/client'
import { TEST_LOCATIONS } from './operations'
import { TestLocations, TestLocationsVariables } from '../../types'

export const useTestLocations = ({ showDeleted }: TestLocationsVariables) =>
    useQuery<TestLocations>(TEST_LOCATIONS, { variables: { showDeleted }})
